import React from 'react';
import { FormikDescriptionField } from './FormikDescriptionField';
import { useLanguageService } from '../../utils/languageContext';

interface MultiLanguageFormikDescriptionFieldProps {
  baseName: string;
  errors: any;
  touched: any;
  values: any;
  onChange?: (e: React.ChangeEvent<any>) => void;
  setFieldValue?: (field: string, value: any) => void;
  placeholderTextKey: string;
  isAdditionalField?: boolean;
  syncWithField?: string;
  rows?: number;
  labelTextKey?: string;
}

export const MultiLanguageFormikDescriptionField: React.FC<MultiLanguageFormikDescriptionFieldProps> = ({
  baseName,
  errors,
  touched,
  values,
  onChange,
  setFieldValue,
  placeholderTextKey,
  isAdditionalField = false,
  syncWithField,
  rows = 4,
  labelTextKey = "descriptionField"
}) => {
  const languageService = useLanguageService();
  const contentLanguages = languageService.getContentLanguages();

  return (
    <>
      {contentLanguages.map((langCode, index) => {
        const name = `${baseName}.${langCode}`;
        
        // Use language-specific label text key
        const descriptionLabelTextKey = `descriptionIn${langCode.toUpperCase()}`;
        
        return (
          <FormikDescriptionField
            key={langCode}
            name={name}
            languageCode={langCode}
            errors={errors}
            touched={touched}
            values={values}
            onChange={onChange}
            setFieldValue={setFieldValue}
            labelTextKey={descriptionLabelTextKey}
            placeholderTextKey={placeholderTextKey}
            isAdditionalField={isAdditionalField}
            syncWithField={syncWithField ? `${syncWithField}.${langCode}` : undefined}
            rows={rows}
          />
        );
      })}
    </>
  );
}; 